export class GameDataFromCacheResponseModel {
    gameMetaData: Map<string, any> = new Map<string, any>();
    gamesNotInCache: string[] = [];
    constructor() {}
}
